import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Alert,
  Typography,
  Switch,
  FormControlLabel,IconButton
} from '@mui/material';
import { adminService } from '../../services/adminService';
import { VisibilityOff, Visibility } from '@mui/icons-material';

const UserModal = ({ open, onClose, onSuccess, user = null }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    role: 'USER',
    isBlocked: false
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        email: user.email || '',
        phone: user.phone || '',
        password: '',
        role: user.role || 'USER',
        isBlocked: user.isBlocked || false
      });
    } else {
      setFormData({
        name: '',
        email: '',
        phone: '',
        password: '',
        role: 'USER',
        isBlocked: false
      });
    }
  }, [user, open]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validation côté client
    // if (!formData.email && !formData.phone) {
    //   setError('Email ou téléphone requis');
    //   setLoading(false);
    //   return;
    // }

    if (!user && !formData.password) {
      setError('Mot de passe requis pour la création');
      setLoading(false);
      return;
    }

    try {
      if (user) {
        // Mise à jour d'un utilisateur existant
        const updateData = { ...formData };
        if (!updateData.password) {
          delete updateData.password; // Ne pas envoyer le mot de passe vide
        }
        await adminService.updateUser(user.id, updateData);
        onSuccess('Utilisateur modifié avec succès');
      } else {
        // Création d'un nouvel utilisateur
        await adminService.createUser(formData);
        onSuccess('Utilisateur créé avec succès');
      }
      onClose();
    } catch (err) {
      console.error('Error in UserModal:', err);
      setError(err.response?.data?.message || 'Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {user ? 'Modifier l\'utilisateur' : 'Créer un utilisateur'}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              name="name"
              label="Nom complet"
              value={formData.name}
              onChange={handleChange}
              required
              fullWidth
            />

            <TextField
              name="email"
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
            />

            <TextField
              name="phone"
              label="Téléphone"
              value={formData.phone}
              onChange={handleChange}
              fullWidth
            />

            <TextField
              name="password"
              label={user ? 'Nouveau mot de passe (laisser vide pour ne pas changer)' : 'Mot de passe'}
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={handleChange}
              required={!user}
              fullWidth
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                )
              }}
            />

            <FormControl fullWidth>
              <InputLabel>Rôle</InputLabel>
              <Select
                name="role"
                value={formData.role}
                onChange={handleChange}
                label="Rôle"
              >
                <MenuItem value="USER">Utilisateur</MenuItem>
                <MenuItem value="VENDOR">Vendeur</MenuItem>
                <MenuItem value="ADMIN">Administrateur</MenuItem>
              </Select>
            </FormControl>

            <FormControlLabel
              control={
                <Switch
                  name="isBlocked"
                  checked={formData.isBlocked}
                  onChange={handleChange}
                />
              }
              label="Utilisateur bloqué"
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Annuler
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? 'Sauvegarde...' : (user ? 'Modifier' : 'Créer')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UserModal;
